<div class="ui basic segment">
    <app-header title="performance.review-index.title" [menuService]="tabMenuService">
        <div class="buttons">
            <ui-button
                *permission="createPermission"
                [routerLink]="
                    !isPerformanceImprovementsFeatureFlagEnabled
                        ? ['/performance/reviews/create']
                        : ['/performance/reviews/create-bulk']
                "
                type="primary"
            >
                <mat-icon svgIcon="plus" aria-hidden="true"></mat-icon>
                <span>{{ 'performance.overview.addReview' | appTranslate }}</span>
            </ui-button>
        </div>
    </app-header>

    <app-table [table]="table">
        <app-empty-state label="performance.overview.noReviewsFound" src="/assets/illustrations/clipboard-star.png">
        </app-empty-state>
    </app-table>
</div>
